import * as React from "react";
import {FC} from "react";
import {FormProvider, useForm} from "react-hook-form";
import {Button, DialogActions, Grid} from "@mui/material";

import {BrickMailDefinition} from "../BrickMailType";
import {TitleText} from "../../../../layout/Typography";
import {FormInputText} from "../../../shop/wholesale/form/FormInputText";
import {FormInputColor} from "../../../shop/wholesale/form/FormInputColor";
import {FormInputCheckbox} from "../../../shop/wholesale/form/FormInputCheckbox";
import {useHeaderEditorStyles} from "../styles/HeaderEditorStyles";

type HeaderEditorProps = {
  header: BrickMailDefinition
  onChange: (header: BrickMailDefinition) => void
  onCancel: () => void
};

export const HeaderEditor: FC<HeaderEditorProps> = ({header, onChange, onCancel, ...props}) => {
  const methods = useForm<BrickMailDefinition>({
    defaultValues: header
  });
  const classes = useHeaderEditorStyles();
  const {control} = methods;

  const {handleSubmit} = methods;
  const formSubmit = handleSubmit((data: BrickMailDefinition) => {
    onChange(data);
  })

  return (
    <div className={classes.headerEditor}>
      <FormProvider {...methods}>
        <form onSubmit={formSubmit} id={"myform"} style={{width: '100%'}}>
          <div>
            <Grid container spacing={"10px"}>
              <Grid item xs={12}>
                <TitleText type={"h2"}>Mail subject</TitleText>
                <FormInputText name={"subject"} control={control} label={"Subject"}/>
              </Grid>
              <Grid item xs={12}>
                <TitleText type={"h2"}>Mail sender</TitleText>
              </Grid>
              <Grid item xs={6}>
                <FormInputText name={"from.name"} control={control} label={"From name"}/>
              </Grid>
              <Grid item xs={6}>
                <FormInputText name={"from.mail"} control={control} label={"From email"}/>
              </Grid>
              <Grid item xs={12}>
                <TitleText type={"h2"}>Body</TitleText>
              </Grid>
              <Grid item xs={4}>
                <FormInputColor name={"body.frameColor"} control={control} label={"Frame color"}
                                defaultColor={"#C0C0C0"}/>
              </Grid>
              <Grid item xs={4}>
                <FormInputText name={"body.framePadding"} control={control} label={"Frame padding"}/>
              </Grid>
              <Grid item xs={4}>
                <FormInputCheckbox name={"body.frame"} control={control} label={"Frame around content?"}/>
              </Grid>
              <Grid item xs={4}>
                <FormInputColor name={"body.backgroundColor"} control={control} label={"Background color"}
                                defaultColor={"#FFFFFF"}/>
              </Grid>
            </Grid>
          </div>
        </form>
      </FormProvider>
      <DialogActions>
        <Button onClick={formSubmit} variant={"contained"}>
          Update
        </Button>
        <Button onClick={onCancel}>
          Hide
        </Button>
      </DialogActions>
    </div>
  );
}